import React from 'react';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import PlayVideoIcon from 'icons/play_video.svg';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  root: {},
  videoContainer: {
    '& button': {
      backgroundColor: 'rgba(0,0,0,0.5)',
      backgroundImage: `url('${PlayVideoIcon}')`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
  },
  iconBackground: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    cursor: 'zoom-in',
  },
  playIcon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',

    padding: 10,
    cursor: 'zoom-in',
  },
}));

const ImageZoom = ({ children, video }) => {
  const classes = useStyles();

  return (
    <div className={video ? classes.videoContainer : null}>
      <Zoom zoomMargin={100}>{children}</Zoom>
    </div>
  );
};

ImageZoom.propTypes = {
  video: PropTypes.bool,
};

ImageZoom.defaultProps = {
  video: false,
};

export default ImageZoom;
